import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaMountain, FaStar, FaSyncAlt } from 'react-icons/fa';
import { trekkingTours } from '../../data/tourData';
import './PopularToursSection.css';

const PopularToursSection = () => {
  const [tours, setTours] = React.useState(trekkingTours.slice(0, 6));
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  const refreshTours = () => {
    setIsRefreshing(true);
    // Shuffle and get random tours
    const shuffled = [...trekkingTours].sort(() => Math.random() - 0.5);
    setTimeout(() => {
      setTours(shuffled.slice(0, 6));
      setIsRefreshing(false);
    }, 1000);
  };

  return (
    <section className="popular-tours">
      <div className="container">
        <div className="section-header">
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            Popular Tour Package
          </motion.h2>
          <div className="section-actions">
            <motion.button 
              className="refresh-btn"
              onClick={refreshTours}
              disabled={isRefreshing}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaSyncAlt className={isRefreshing ? 'spinning' : ''} />
              <span>✨ Discover New Adventures</span>
            </motion.button>
            <Link to="/trekking-tours" className="view-all-link">
              View All Trekking →
            </Link>
          </div>
        </div>
        
        <div className="tours-grid">
          {tours.map((tour, index) => (
            <motion.div
              key={tour.id}
              className="tour-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              <Link to={tour.link} className="tour-card-link">
                <div className="tour-image">
                  <img src={tour.image} alt={tour.name} />
                  <div className="tour-duration">{tour.duration}</div>
                </div>
                <div className="tour-content">
                  <h3>{tour.name}</h3>
                  <div className="tour-highlights">
                    <span>
                      <FaMountain />
                      {tour.altitude}
                    </span>
                    <span>
                      <FaStar />
                      {tour.difficulty}
                    </span>
                  </div>
                  <div className="tour-price">
                    <span className="price-label">Starting From</span>
                    <span className="price">{tour.price}</span>
                  </div>
                  <div className="book-btn">View Details</div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularToursSection;
